import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { DataboxDmsMessageGridObject } from '@libs/types/src/inbox/object-type/databox-dms-message.object';
import { filterFrag } from '../../../services/types/filter.types';
import { InboxMessagesSetReadInput } from '@libs/types/src/inbox/input-type/inbox-messages-set-read.input';
import { InboxMessageIdsInput } from '@libs/types/src/inbox/input-type/inbox-message-ids.input';
import { DataboxDmsMessageCreateInput } from '@libs/types/src/inbox/input-type/databox-dms-message-create.input';
import { InboxMessageLabelAssignInput } from '@libs/types/src/inbox/input-type/inbox-message-label.assign-input';
import { InboxMessageLabelUnassignInput } from '@libs/types/src/inbox/input-type/inbox-message-label.unassign-input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class DataboxDmsMessageGqlService extends GqlServiceV2 {

    getDataboxMessages(input: GridInput, frag: string) {
        return this.query<DataboxDmsMessageGridObject>(
            `
                query($input: GridInput!) {
                    databoxDmsMessage {
                        filterDataboxMessages(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    getDmsMessages(input: GridInput, frag: string) {
        return this.query<DataboxDmsMessageGridObject>(
            `
                query($input: GridInput!) {
                    databoxDmsMessage {
                        filterDmsMessages(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    setDataboxDmsMessagesRead(input: InboxMessagesSetReadInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessagesSetReadInput!) {
                databoxDmsMessage {
                    setRead(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteReceivedDataboxDmsMessages(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                databoxDmsMessage {
                    deleteReceivedMessages(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteToBeSentDataboxDmsMessages(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                databoxDmsMessage {
                    deleteToBeSentMessages(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    restoreDataboxDmsMessages(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                databoxDmsMessage {
                    restore(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    createDataboxDmsMessage(input: DataboxDmsMessageCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: DataboxDmsMessageCreateInput!) {
                databoxDmsMessage {
                    create(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    assignLabelToDataboxDmsMessage(input: InboxMessageLabelAssignInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageLabelAssignInput!) {
                databoxDmsMessage {
                    assignLabel(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    unassignLabelFromDataboxDmsMessage(input: InboxMessageLabelUnassignInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageLabelUnassignInput!) {
                databoxDmsMessage {
                    unassignLabel(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
